export default __webpack_public_path__ + "static/media/graph-token.37eb98ff.svg";